import graphqlClient from "./graphqlClient";
import {
  COMMON_FIELDS,
  FIELDS,
  FIELDS_WITHOUT_VALUES_CLAUSE,
  QUERY_INFO,
  SEARCH,
  TYPES
} from "./graphql/pits-queries";

export default class PitsApi {
  search(query, limit = 10, page = 0, feedPreference, searchType = "UNIFIED") {
    feedPreference = feedPreference ? feedPreference : null;
    const queryType = "STRUCTURED";
    return graphqlClient
      .query({
        query: SEARCH,
        variables: { query, limit, page, queryType, feedPreference, searchType },
        fetchPolicy: "network-only"
      })
      .then(r => r.data)
      .then(r => {
        return r.search;
      });
  }

  getFields(searchType = "UNIFIED") {
    return graphqlClient
      .query({
        query: FIELDS_WITHOUT_VALUES_CLAUSE,
        variables: { searchType }
      })
      .then(r => r.data)
      .then(r => {
        return r.fields;
      });
  }

  getQueryInfo(queries, queryType = "STRUCTURED") {
    return graphqlClient
      .query({
        query: QUERY_INFO,
        variables: { queries, queryType }
      })
      .then(r => r.data)
      .then(r => {
        return r.queryInfo;
      });
  }

  getFieldValues(fieldId, searchType = "UNIFIED") {
    return graphqlClient
      .query({
        query: FIELDS,
        variables: { ids: [fieldId], searchType }
      })
      .then(r => r.data)
      .then(r => {
        return r.fields[0].values;
      });
  }

  getTypes() {
    return graphqlClient
      .query({
        query: TYPES
      })
      .then(r => r.data)
      .then(r => {
        return r.types;
      });
  }

  getCommonFields(playIds) {
    return graphqlClient
      .query({
        query: COMMON_FIELDS,
        variables: { plays: playIds }
      })
      .then(r => r.data)
      .then(r => {
        return r.commonFields;
      });
  }
}



// WEBPACK FOOTER //
// ./src/httpClients/PitsApi.js